export default {
  AN: /[^a-zA-Z0-9-]+/g,
  N: /[^\d-]+/g,
  A: /[^a-zA-Z-]+/g,
  ALL: /[^a-zA-Z0-9]*$/,
};
